export default __webpack_public_path__ + "static/media/ic_caret_down_white.382b4a0d.svg";